import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from 'react-oidc-context';
import { App } from './App.tsx';
import { AuthGate } from './auth/AuthGate.tsx';
import { cognitoConfig } from './auth/config.ts';
import { createQueryClient } from './queryClient.ts';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

const queryClient = createQueryClient();

// Cognito mode (AWS, PRD-0006 D9): OIDC code flow + PKCE against the user
// pool, Google as the sole IdP (extraQueryParams skips Cognito's own account
// chooser — IAP-like straight-to-Google). Without VITE_COGNITO_* (local dev,
// IAP deployment) the tree renders exactly as before.
const cognito = cognitoConfig();

const app = (
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

createRoot(root).render(
  <StrictMode>
    {cognito ? (
      <AuthProvider
        authority={cognito.authority}
        client_id={cognito.clientId}
        redirect_uri={`${window.location.origin}/auth/callback`}
        response_type="code"
        scope="openid email profile"
        extraQueryParams={{ identity_provider: 'Google' }}
        automaticSilentRenew
        onSigninCallback={() => {
          // Back to the app root once the ?code= exchange completes.
          window.history.replaceState({}, document.title, '/');
        }}
      >
        <AuthGate>{app}</AuthGate>
      </AuthProvider>
    ) : (
      app
    )}
  </StrictMode>,
);
